export const entity_language = {
    entity: {
        user: 'Utenti',
        user_group: 'Gruppi',
        log: 'Log di sistema',
        user_entity_saved_filters: 'Filtri salvati',
        user_entity_preferences: 'Preferenze entità',
        location: 'Sedi',
        sector: 'Settori',
        role: 'Ruoli',
        agency: 'Agenzie',
        tag: 'Tag',
        job_post: 'Posizioni',
        job_request: 'Candidature',
        job_post_favourites: 'Posizioni salvate',
        job_request_answer: 'Domande posizione'
    },
    labels: {
        "user": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo',
            "name": 'Nome',
            "surname": 'Cognome',
            "nameComplete": 'Nome completo',
            "username": 'Username',
            "email": 'Email',
            "level": 'Livello utente',
            "level.options.0": 'Admin',
            "level.options.1": 'Selezionatore',
            "level.options.2": 'Candidato',
            "avatar": 'Avatar',
            "password": 'Password',
            "phone": 'Telefono',
            "birthDate": 'Data di nascita',
            "country": 'Nazione',
            "province": 'Provincia',
            "notificationsStatusJob": 'Notifiche stato candidatura',
            "notificationsNewJob": 'Notifiche nuove posizioni',
            "privacyPolicy": 'Accettazione privacy policy',
        },
        "user_group": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome gruppo',
        },
        "log": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItem": 'Id elemento',
            "idUser": 'Utente',
            "entity": 'Entità',
            "operation": 'Operazione',
            "operation.options.0_DELETE": 'Elimina',
            "operation.options.1_EDIT": 'Modifica',
            "operation.options.2_ADD": 'Aggiungi',
            "operation.options.3_LOGIN": 'Login',
            "operation.options.4_LOGOUT": 'Logout',
            "notes": 'Note',
        },
        "user_entity_saved_filters": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "name": 'Nome',
            "notes": 'Note',
            "content": 'Json filtri'
        },
        "user_entity_preferences": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "content": 'Json preferenze'
        },
        "location": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "address": 'Indirizzo',
            "city": 'Città',
            "country": 'Nazione',
            "countryCode": 'Codice nazione',
        },
        "sector": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
        },
        "country": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
        },
        "role": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
        },
        "agency": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
        },
        "tag": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
        },
        "job_post": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "title": 'Titolo',
            "description": 'Descrizione',
            "status": 'Stato',
            "status.options.0_DRAFT": 'In bozza',
            "status.options.10_OPEN": 'Aperta',
            "status.options.20_CLOSED": 'Chiusa',
            "idLocation": 'Sede',
            "idCountry": 'Nazione',
            "idRole": 'Ruolo',
            "idSector": 'Settore',
            "questions": 'Domande posizione',
            "tags": 'Tag',
        },
        "job_post_questions": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "title": 'Titolo',
            "idJobPost": 'Posizione',
            "type": 'Tipo dato',
            "type.options.0_STRING": 'Stringa',
            "type.options.10_FILE": 'File',
            "type.options.20_TEXT": 'Testo',
            "type.options.30_DATA": 'Data',
        },
        "job_post_favourites": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "title": 'Titolo',
            "idJobPost": 'Posizione',
            "idUser": 'Candidato'
        },
        "job_request": {
            "id": 'id',
            "date": 'Data candidatura',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUser": 'Candidato',
            "idJobPost": 'Posizione',
            "source": 'Fonte',
            "source.options.0_WEBSITE": 'Sito web',
            "source.options.10_AGENCY": 'Agenzia',
            "source.options.20_LINKEDIN": 'Linkedin',
            "source.options.30_INTERNAL": 'Fonte interna',
            "idLocation": 'Sede',
            "idAgency": 'Agenzia',
            "proposalSent": 'Proposta inviata',
            "hired": 'Assunto',
            "interviewDate": 'Data colloquio',
            "idSelector": 'Selezionatore',
            "interviewNotes": 'Note colloquio',
            "answer": 'Risposte',
        },
        "job_request_answer": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idJobPostQuestion": 'Domanda posizione',
            "answerString": 'Risposta breve',
            "answerText": 'Risposta testo',
            "answerFile": 'Risposta file',
        },
    }
};